import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomTextField from '../../shared/CustomTextField';
import CustomDropDown from '../../shared/CustomDropDown';
import CustomPicker from '../../shared/CustomPicker';
import CustomUploadField from '../../shared/CustomUploadField';
import CustomRadioGroup from '../../shared/CustomRadioGroup';
import CustomGroupCheckbox from '../../shared/CustomGroupCheckbox';
import ScoreParameters from './ScoreParameters';
import RankingLogic from './RankingLogic';
import { contestCategories, contestDurationTypes, options, visibility } from '../constants';
import CsvUploadField from './CsvUploadField';
import ScoreParametersDefault from './ScoreParametersDefault';
import ZeroState from '../../common/ZeroState';
import FileIcon from '../../../assets/FileIcon';

const useStyles = makeStyles(() => ({
  title: {
    margin: '16px 0px 0px 20px',
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  publishDateField: {
    width: '438px',
    height: '44px',
    padding: '12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
  },
  detailsContainer: {
    padding: '15px 15px 0px 15px',
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    background: 'white', // Background color to ensure visibility
    padding: '10px',
    zIndex: 10, // Ensure it's above other elements
  },
}));
const ContestInfo = ({
  handleDataChange,
  data,
  handleDateChange,
  handleDeleteLogo,
  thumbnail,
  logoFilename,
  csvFilename,
  add,
  networkPartnerList,
  enableNetworkPartnerID,
  metaColumns,
}) => {
  const classes = useStyles();

  const getNetworkPartnerValue = () =>
    networkPartnerList?.filter((item) => item.id === data?.rockedNetworkPartnerId)[0]?.displayName;

  return (
    <>
      <Grid container direction="row" className={classes.detailsContainer}>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Contest Name" required />
            </Grid>
            <Grid item>
              <CustomTextField
                name="name"
                rows={1}
                placeholder="Contest Name"
                id="name_id"
                height="44px"
                width="482px"
                handleChange={handleDataChange}
                value={data.name}
                multiline={false}
              />
            </Grid>
            <Grid item>
              <CustomPopupText text="Category" required />
            </Grid>
            <Grid item>
              <CustomDropDown
                list={contestCategories}
                height="44px"
                width="482px"
                marginBottom="20px"
                name="category"
                handleChange={handleDataChange}
                value="IMPORT"
                disabled
              />
            </Grid>
            {enableNetworkPartnerID || (data?.category === 'IMPORT' && !add) ? (
              <>
                <Grid item>
                  <CustomPopupText text="Network Partner ID" required />
                </Grid>
                <Grid item>
                  <CustomDropDown
                    list={networkPartnerList}
                    height="44px"
                    width="482px"
                    marginBottom="20px"
                    name="rockedNetworkPartnerId"
                    handleChange={handleDataChange}
                    value={getNetworkPartnerValue()}
                  />
                </Grid>
              </>
            ) : null}

            <Grid item>
              <CustomPopupText text="Start Date" required />
            </Grid>
            <Grid item>
              <CustomPicker
                type="default"
                data={data}
                handleDateChange={handleDateChange}
                customStyles={classes.publishDateField}
                name="startDate"
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Contest Logo" required />
            </Grid>
            <Grid item>
              <CustomUploadField
                type="image"
                name="logo"
                value={thumbnail}
                handleChange={handleDataChange}
                handleDelete={handleDeleteLogo}
                fileName={logoFilename}
                customStyles={{ height: '44px', width: '482px' }}
                imgSrc={data?.logo}
              />
            </Grid>
            <Grid item>
              <CustomPopupText text="Duration Type" required />
            </Grid>
            <Grid item>
              <CustomDropDown
                list={contestDurationTypes}
                height="44px"
                width="482px"
                marginBottom="20px"
                name="type"
                handleChange={handleDataChange}
                value={data.type}
              />
            </Grid>
            {data?.category === 'IMPORT' && (
              <>
                <Grid item>
                  <CustomPopupText text="Import Metadata" required />
                </Grid>
                <Grid item>
                  <CsvUploadField
                    name="csvFile"
                    handleChange={handleDataChange}
                    handleDelete={handleDeleteLogo}
                    fileName={csvFilename}
                    height="44px"
                    width="482px"
                  />
                </Grid>
              </>
            )}
            <Grid item>
              <CustomPopupText text="End Date" required />
            </Grid>
            <Grid item>
              <CustomPicker
                name="endDate"
                type="default"
                data={data}
                handleDateChange={handleDateChange}
                customStyles={classes.publishDateField}
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.detailsContainer} style={{ height: '110px' }}>
        <Grid item xs={12}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Highlight Top Ranks" required />
            </Grid>
            <Grid item>
              <CustomTextField
                name="highlightTopScoreLogic"
                rows={4}
                placeholder="Highlight Top Ranks JSON"
                id="highlight_id"
                height="64px"
                handleChange={handleDataChange}
                value={data.highlightTopScoreLogic}
                width="100%"
                multiline
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.detailsContainer}>
        <Grid item xs={6}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <CustomPopupText text="Leaderboard Status :" />
            </Grid>
            <Grid item>
              <CustomRadioGroup
                value={data?.enabled}
                handleChange={handleDataChange}
                name="enabled"
                options={options}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <CustomPopupText text="Leaderboard Visibility :" />
            </Grid>
            <Grid item>
              <CustomGroupCheckbox data={data} handleChange={handleDataChange} name="visibility" options={visibility} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {metaColumns && data?.category === 'IMPORT' ? (
        <>
          <Grid container direction="column" className={classes.detailsContainer}>
            <Grid item xs={6}>
              <ScoreParameters data={data} metaColumns={metaColumns} handleChange={handleDataChange} />
            </Grid>
          </Grid>

          <Grid container direction="column" className={classes.detailsContainer} style={{ paddingBottom: '15px' }}>
            <Grid item xs={12}>
              <RankingLogic
                data={data}
                handleChange={handleDataChange}
                metaColumns={metaColumns || data.scoreBreakupParameters}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        !metaColumns &&
        data?.category === 'IMPORT' && (
          <Grid container direction="column">
            <Grid item>
              <Typography className={classes.title}>Score parameters</Typography>
            </Grid>
            <Grid item>
              <ZeroState
                Icon={FileIcon}
                title="Import Data to define the scoring logic"
                style={{ marginTop: '16px', marginLeft: '20px' }}
                cardWidth="100%"
              />
            </Grid>
            <Grid item>
              <Typography className={classes.title}>Ranking Logic</Typography>
            </Grid>
            <Grid item>
              <ZeroState
                Icon={FileIcon}
                title="Import Data to define the ranking logic"
                style={{ paddingBottom: '50px', marginTop: '16px', marginLeft: '20px' }}
                cardWidth="100%"
              />
            </Grid>
          </Grid>
        )
      )}

      {data?.category === 'DEFAULT' && (
        <Grid container direction="column" className={classes.detailsContainer}>
          <Grid item xs={12}>
            <ScoreParametersDefault add data={data} handleChange={handleDataChange} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ContestInfo;
